var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["question-builder-container", "level-" + _vm.level] },
    [
      _c(
        "div",
        {
          staticClass: "row single-quesion-box",
          style: { marginLeft: _vm.level * 5 + "px" }
        },
        [
          _c(
            "h3",
            {
              staticStyle: {
                "text-align": "center",
                color: "#782B55",
                "margin-bottom": "15px",
                "font-weight": "bold"
              }
            },
            [
              _vm.level > 0
                ? _c("span", { staticStyle: { color: "#999" } }, [
                    _vm._v("↳ Follow-up ")
                  ])
                : _vm._e(),
              _vm._v(
                "\n      Question " +
                  _vm._s(_vm.displayQuestionNumber) +
                  "\n    "
              )
            ]
          ),
          _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.question.question,
                  expression: "question.question"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has(
                  "add-survey." + _vm.fieldName("surveyQuestion")
                )
              },
              attrs: {
                type: "text",
                maxlength: "60",
                placeholder:
                  "Enter Question " + _vm.displayQuestionNumber + " Text",
                name: _vm.fieldName("surveyQuestion")
              },
              domProps: { value: _vm.question.question },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.question, "question", $event.target.value)
                }
              }
            })
          ]),
          _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.question.questionType,
                    expression: "question.questionType"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has(
                    "add-survey." + _vm.fieldName("surveyQuestionType")
                  )
                },
                attrs: { name: _vm.fieldName("surveyQuestionType") },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.question,
                      "questionType",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("Select Answer Type")
                ]),
                _vm.basicSurveyDetails.type !== "NON_GEO"
                  ? _c("option", { attrs: { value: "SINGLE_ANSWER" } }, [
                      _vm._v("Single Select")
                    ])
                  : _vm._e(),
                _vm.basicSurveyDetails.type !== "NON_GEO"
                  ? _c("option", { attrs: { value: "MULTIPLE_ANSWER" } }, [
                      _vm._v("Multi Select")
                    ])
                  : _vm._e(),
                _c("option", { attrs: { value: "TEXT" } }, [
                  _vm._v("Textual Value")
                ])
              ]
            )
          ]),
          _vm.question.questionType !== "TEXT" &&
          _vm.basicSurveyDetails.type !== "NON_GEO"
            ? _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _vm._l(_vm.question.answers, function(answer, ai) {
                    return _c(
                      "div",
                      { key: ai, staticClass: "answer-section" },
                      [
                        _c("div", { staticClass: "row answer-container" }, [
                          _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: answer.answerOption,
                                  expression: "answer.answerOption"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "answer-input",
                              class: {
                                input: true,
                                "is-danger": _vm.errors.has(
                                  "add-survey." +
                                    _vm.fieldName("surveyAnswers", ai)
                                )
                              },
                              attrs: {
                                maxlength: "40",
                                type: "text",
                                placeholder: "Answer " + (ai + 1),
                                name: _vm.fieldName("surveyAnswers", ai)
                              },
                              domProps: { value: answer.answerOption },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    answer,
                                    "answerOption",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            ai > 1
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "pull-right remove-answer-button",
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeAnswerHandler(ai)
                                      }
                                    }
                                  },
                                  [_vm._v("x")]
                                )
                              : _vm._e()
                          ]),
                          _vm.basicSurveyDetails.surveyType ==
                          "conditional_base"
                            ? _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                                _vm.canAddFollowUp(ai)
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "add-followup-btn",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.addFollowUpHandler(ai)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              + Add Follow-up Question\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]),
                        answer.followUpQuestions &&
                        answer.followUpQuestions.length > 0
                          ? _c(
                              "div",
                              { staticClass: "followup-questions-container" },
                              _vm._l(answer.followUpQuestions, function(
                                followUpQuestion,
                                fqi
                              ) {
                                return _c("QuestionBuilder", {
                                  key: "followup-" + ai + "-" + fqi,
                                  attrs: {
                                    question: followUpQuestion,
                                    questionIndex: fqi,
                                    questionPath: _vm.questionPath.concat(
                                      [ai],
                                      [fqi]
                                    ),
                                    parentPath: _vm.questionPath,
                                    level: _vm.level + 1,
                                    basicSurveyDetails: _vm.basicSurveyDetails,
                                    errors: _vm.errors,
                                    validator: _vm.validator
                                  },
                                  on: {
                                    "remove-question": function($event) {
                                      return _vm.removeFollowUpHandler(ai, fqi)
                                    },
                                    "add-answer": function($event) {
                                      return _vm.bubbleEvent(
                                        "add-answer",
                                        $event
                                      )
                                    },
                                    "remove-answer": function($event) {
                                      return _vm.bubbleEvent(
                                        "remove-answer",
                                        $event
                                      )
                                    },
                                    "add-followup": function($event) {
                                      return _vm.bubbleEvent(
                                        "add-followup",
                                        $event
                                      )
                                    },
                                    "remove-followup": function($event) {
                                      return _vm.bubbleEvent(
                                        "remove-followup",
                                        $event
                                      )
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm.canAddMoreAnswers
                    ? _c(
                        "a",
                        {
                          staticClass: "add-more-ans",
                          attrs: { href: "javascript:;" },
                          on: { click: _vm.addAnswerHandler }
                        },
                        [_vm._v("\n        Add Another Answer\n      ")]
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm.level === 0 && _vm.questionIndex > 0
            ? _c(
                "a",
                {
                  staticClass: "pull-right delete-question-link",
                  attrs: { href: "javascript:;" },
                  on: { click: _vm.removeQuestionHandler }
                },
                [_vm._v("\n      Delete Question\n    ")]
              )
            : _vm._e(),
          _vm.level > 0
            ? _c(
                "a",
                {
                  staticClass: "pull-right delete-question-link",
                  attrs: { href: "javascript:;" },
                  on: { click: _vm.removeQuestionHandler }
                },
                [_vm._v("\n      Delete Follow-up\n    ")]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }